module.exports = __webpack_public_path__ + "img/house_basic.df39f1ba.gif";